import { Pipe, PipeTransform } from '@angular/core';
import { CartService } from 'src/app/web/cart/cart.service';

@Pipe({
  name: 'ingredientName',
  standalone: true,
})
export class IngredientNamePipe implements PipeTransform {
  constructor(private cartService: CartService) {}

  transform(ingredientId: number): string {
    const product = this.cartService.ingredientsList.find(
      (element) => element.productIngredientId == ingredientId
    );

    return ` ${product?.name}` || '';
  }
}
